import React from 'react';
import { Gift, Copy, Check } from 'lucide-react';

interface ReferralContentProps {
  referralUrl: string;
  copied: boolean;
  onCopy: () => void;
  onViewTerms: () => void;
  isMobile?: boolean;
}

const ReferralContent: React.FC<ReferralContentProps> = ({
  referralUrl,
  copied,
  onCopy,
  onViewTerms,
  isMobile = false,
}) => {
  return (
    <div className={isMobile ? 'p-4' : ''}>
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-6 text-center mb-6 relative">
        {/* Earn Badge - Top Left */}
        <div className="absolute top-3 left-3 px-2.5 py-1 bg-purple-600 text-white text-xs font-semibold rounded-full">
          Earn up 10+ FitCoins
        </div>
        
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gradient-to-br from-purple-100 to-pink-100 flex items-center justify-center">
          <Gift className="text-purple-600" size={32} />
        </div>
        <h4 className="text-2xl font-bold text-gray-900 mb-2">Share the fashion experience</h4>
        <p className="text-sm text-gray-500 max-w-xs mx-auto leading-relaxed">
          Invite friends to explore virtual outfit experiences and discover creative designs they’ll love to try
        </p>
      </div>

      {/* How It Works */}
      <div className="mb-6">
        <h5 className="text-sm font-semibold text-gray-900 mb-3">How it works</h5>
        <div className="space-y-2.5">
          <div className="flex items-start gap-2.5">
            <div className="w-1.5 h-1.5 rounded-full bg-purple-600 flex-shrink-0 mt-1.5"></div>
            <p className="text-sm text-gray-700">
              When friends sign up, <span className="font-semibold text-gray-900">they earn 12 FitCoins</span>
            </p>
          </div>
          <div className="flex items-start gap-2.5">
            <div className="w-1.5 h-1.5 rounded-full bg-purple-600 flex-shrink-0 mt-1.5"></div>
            <p className="text-sm text-gray-700">
              <span className="font-semibold text-gray-900">You earn 12 FitCoins daily</span>
            </p>
          </div>
          <div className="flex items-start gap-2.5">
            <div className="w-1.5 h-1.5 rounded-full bg-purple-600 flex-shrink-0 mt-1.5"></div>
            <p className="text-sm text-gray-700">
              When they purchase their first FitCoins, <span className="font-semibold text-gray-900">you earn 20 FitCoins</span>
            </p>
          </div>
        </div>
      </div>

      {/* Referral Link */}
      <div className="bg-gray-50 rounded-lg p-4">
        <label className="text-xs font-semibold text-gray-600 mb-2 block">Your Referral Link</label>
        {isMobile ? (
          <div className="flex flex-col gap-2">
            <input
              type="text"
              value={referralUrl}
              readOnly
              className="w-full px-3 py-2 bg-white border border-gray-200 rounded-lg text-sm text-gray-700 focus:outline-none"
            />
            <button
              onClick={onCopy}
              className="w-full px-4 py-3 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors flex items-center justify-center gap-2"
            >
              {copied ? <Check size={18} /> : <Copy size={18} />}
              <span className="font-medium">{copied ? 'Copied!' : 'Copy Link'}</span>
            </button>
          </div>
        ) : (
          <div className="flex items-center gap-2">
            <input
              type="text"
              value={referralUrl}
              readOnly
              className="flex-1 px-3 py-2 bg-white border border-gray-200 rounded-lg text-sm text-gray-700 focus:outline-none"
            />
            <button
              onClick={onCopy}
              className="px-4 py-2 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors flex items-center gap-2"
            >
              {copied ? <Check size={16} /> : <Copy size={16} />}
              <span className="text-sm font-medium">{copied ? 'Copied' : 'Copy'}</span>
            </button>
          </div>
        )}
        
        {/* Terms and Conditions */}
        <div className="mt-3 text-center">
          <button
            onClick={onViewTerms}
            className="text-xs text-gray-500 hover:text-gray-700 underline transition-colors"
          >
            View terms and conditions
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReferralContent;
